import { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles.css';

import { API_URL } from '../config';

function VerifyEmail() {
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('Verifying your email...');
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        
        if (!token) {
          setStatus('error');
          setError('No verification token found');
          return;
        }

        const response = await axios.get(`${API_URL}/api/verify-email?token=${token}`);
        setStatus('success');
        setMessage(response.data.message);
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          window.location.href = '/login';
        }, 3000);
        
      } catch (err) {
        setStatus('error');
        setError(err.response?.data?.error || 'Verification failed');
      }
    };

    verifyEmail();
  }, []);

  return (
    <div className="login-container">
      <h1>Email Verification</h1>
      
      {status === 'verifying' && (
        <div className="verification-status">
          <p>{message}</p>
          <div className="spinner">Loading...</div>
        </div>
      )}
      
      {status === 'success' && (
        <div className="verification-success">
          <p className="success">{message}</p>
          <p>Redirecting to login page...</p>
        </div>
      )}
      
      {status === 'error' && (
        <div className="verification-error">
          <p className="error">{error}</p>
          <button onClick={() => window.location.href = '/login'}>
            Go to Login
          </button>
        </div>
      )}
    </div>
  );
}

export default VerifyEmail;
